export default "__VITE_ASSET__Dltbt5vT__"